import actions from "@/store/modules/bookings/actions";
import mutations from "@/store/modules/bookings/mutations";
import bookingsGetters from "@/store/modules/bookings/getters";
import interviews from "@/store/modules/bookings/interviews";

export const INITIAL_BOOKING_STATE = {
  bookings: [],
  currentBooking: null,
  currentBookingCandidates: [],
  currentBookingPublishingSchedule: [],
  bookingComments: [],
  candidatesForSubmit: [],
  isFetchingBookings: false,
  isFetchingCurrentBooking: false,
  isFetchingCurrentBookingCandidates: false,
  isFetchingBookingPublishingSchedule: false,
  isFetchingBookingComments: false,
  isFetchingCandidatesForSubmit: false,
  evaluationStatuses: [],
  isFetchingSharingUsers: false,
  sharingUsers: [],
  bookingOptions: {},
  isFetchingBookingOptions: false,
  usersForSharing: [],
  bookingListFilters: {},
  publishingChannels: [],
  isFetchingPublishingChannels: false
};

export default {
  namespaced: true,
  state: { ...INITIAL_BOOKING_STATE },
  actions,
  mutations,
  getters: bookingsGetters,
  modules: {
    interviews
  }
};
